import { Injectable } from "@angular/core";
@Injectable()
export class DocumentTypes {
    public CONTRACT = 1;
    public COLLECTION = 2;
    public RETURN = 3;
    public INVOICE = 4;
    public QUOTATION = 5;
    public ORDER = 6;
    public SERVICEJOB = 7;
    public SIGNDOCUMENT = 8;
    public MODIFYCONTRACT = 9;
    public CHANGEOVER = 10;
    public CONTRACTFROMORDER = 11;
    public HANDOVER = 12;
    // dodge unlucky 13
    public STRIKETHROUGH = 14;
    public OPPORTUNITY = 15;
    public OFFHIRE = 16;
    public BREAKDOWN = 17;
    public BREAKDOWN_COLLECTION = 18;
    public LOAN = 19;
    public CUSTOMERREPAIR = 20;

    public CONTRACTAUTOCREATEACCESSORIES = 100;
    public QUOTATIONAUTOCREATEACCESSORIES = 101;

    public STOCKING = 102;
    public TRANSFERWARD = 103;
    public CONTRACTANDCOLLECTION = 104;

    public STOCKCOUNT = 500;
    public PURCHASEORDER = 501;

    getDocumentTypeDescription(docType): string {
        switch (docType) {
            case 1: {
                return 'Contract';
            }
            case 2: {
                return 'Collection/Offhire';
            }
            case 3: {
                return 'Return';
            }
            case 4: {
                return 'Invoice';
            }
            case 5: {
                return 'Quotation';
            }
            case 6: {
                return 'Order';
            }
            case 7: {
                return 'Service Job';
            }
            case 8: {
                return 'Sign Document';
            }
            case 9: {
                return 'Modify Contract';
            }
            case 10: {
                return 'Change Over';
            }
            case 12: {
                return 'Hand Over';
            }
            case 14: {
                return 'Strike Through';
            }
            case 15: {
                return 'Opportunity';
            }
            case 16: {
                return 'Collection/Offhire';
            }
            case 501: {
                return 'Purchase Order';
            }
            default: {
                return 'alert';
            }
        }
    }
}
